import { useRouter } from 'next/router'

import { useState } from 'react'

import { Response_WorkDetailEpisode } from '@/api/@types'
import { AppDownloadDialog } from '@/components/common/Feedback/Dialog/AppDownloadDialog'
import { pagesPath } from '@/lib/$path'

import { getIsMobile } from '@/utils/getIsMobile'
import { getMobileOS } from '@/utils/getMobileOS'

import { Episode } from '../Episode'

type WorkEpisodeProps = {
  episodes: Response_WorkDetailEpisode[] | undefined
}

export const WorkEpisode = ({ episodes }: WorkEpisodeProps) => {
  const router = useRouter()
  const [isAppDownloadDialogOpen, setIsAppDownloadDialogOpen] = useState(false)

  const handleClick = (isFree: boolean, episodeId: string) => {
    if (isFree) {
      router.push(pagesPath.episodes._uuid(episodeId).$url())
    } else {
      const isMobile = getIsMobile()
      if (isMobile) {
        const os = getMobileOS()
        switch (os) {
          case 'iOS':
            // TODO: AppStoreリリース後にURLを変更する
            router.push(
              'https://apps.apple.com/jp/app/bump-%E3%83%90%E3%83%B3%E3%83%97-%E3%82%B7%E3%83%A7%E3%83%BC%E3%83%88%E3%83%89%E3%83%A9%E3%83%9E%E9%85%8D%E4%BF%A1%E3%82%A2%E3%83%97%E3%83%AA/id1630710367'
            )
            break
          case 'Android':
            // TODO: GooglePlayリリース後にURLを変更する
            router.push(
              'https://play.google.com/store/apps/details?id=com.emole.bump'
            )
            break
          default:
            setIsAppDownloadDialogOpen(true)
        }
      } else {
        setIsAppDownloadDialogOpen(true)
      }
    }
  }

  return (
    <>
      <section aria-labelledby="work-episode" className="pt-16 pb-32">
        <h2 id="work-episode" className="mb-16 text-md font-bold">
          エピソード
        </h2>
        <div className="space-y-16">
          {episodes?.map(episode => (
            <Episode
              key={episode?.id}
              {...episode}
              onClick={() => {
                handleClick(episode?.isFree ?? false, episode?.id ?? '')
              }}
            />
          ))}
        </div>
      </section>

      <AppDownloadDialog
        isOpen={isAppDownloadDialogOpen}
        onClose={() => {
          setIsAppDownloadDialogOpen(false)
        }}
      />
    </>
  )
}
